<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import axios from "axios";
import Earning from "./earning";
import TopSelling from "./top-selling.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import simplebar from "simplebar-vue";
import { required } from "vuelidate/lib/validators";
import { FormWizard, TabContent } from "vue-form-wizard";
import { salesAnalyticsDonutChart } from "./data";
import Swal from "sweetalert2";
/**
 * Saas Dashboard Component
 */
export default {
  page: {
    title: "Insights",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    VueEasyLightbox,
    simplebar,
    Layout,
    PageHeader,
    FormWizard,
    TabContent,
    Earning,
    TopSelling,
  },
  data() {
    return {
      salesAnalyticsDonutChart: salesAnalyticsDonutChart,
      ChatData: [],
      title: "Insights",
      index: 0,
      loader: false,
      empMap: new Map(),
      proMap: new Map(),
      projects: [],
      presentListModal: false,
      absentListModal: false,
      onlineListModal: false,
      btnText: 'Copy Download Link',
      visible: false,
      companyDetailsLoader: false,
      dashboardAttDataLoader: false,
      dashboardActivityDataLoader: false,
      dashboardAppDataLoader: false,
      companyDetails: {},
      loginData: {},
      showAlertsModel: false,
      showDownloadsModel: false,
      showStartJourneyModel: false,
      todaysDayOfWeek: 0,
      imgs: [
        //"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="
      ],
      quotes: [
        {       
          day: "menuitems.dashboards.data.sunday.value",
          quote: "menuitems.dashboards.data.sunday.text",
        },
        {       
          day: "menuitems.dashboards.data.monday.value",
          quote: "menuitems.dashboards.data.monday.text",
        },
        {       
          day: "menuitems.dashboards.data.tuesday.value",
          quote: "menuitems.dashboards.data.tuesday.text",
        },
        {       
          day: "menuitems.dashboards.data.wednesday.value",
          quote: "menuitems.dashboards.data.wednesday.text",
        },
        {       
          day: "menuitems.dashboards.data.thursday.value",
          quote: "menuitems.dashboards.data.thursday.text",
        },
        {       
          day: "menuitems.dashboards.data.friday.value",
          quote: "menuitems.dashboards.data.friday.text",
        },
        {       
          day: "menuitems.dashboards.data.saturday.value",
          quote: "menuitems.dashboards.data.saturday.text",
        },
      ],
      dashboardAttendanceData: {
        presentToday: 0,
        absentToday: 0,
        onlineToday: 0,
        avgAttendance: 0,
        isIncreased: 0,
        percentageChanged: 0,
      },
      dashboardActivityData: {
      },
      dashboardAppData: {
        appsBlocked: 0,
        isIncreased: 0,
        percentageChanged: 0,
        mostAppBlocked: [],
      },
      submitted: false,
      workingHrsLoader: false,
      chat: {
        noticeId: 0,
        companyId: 1,
        message: "",
        time: "",
        timestamp: 0,
      },
    };
  },
  validations: {
    chat: {
      message: {
        required,
      },
    },
  },
  methods: {
    /**
     * Char form Submit
     */
    // eslint-disable-next-line no-unused-vars
    showImg(index) {
      this.index = index;
      this.visible = true;
    },
    showStartJourneySubmit() {
      this.$router.push('/employee/list');
    },
    handleHide() {
      this.visible = false;
    },
    async getAllEmployees() {
      
      try {
        let response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/employee/get_all",
          { params: { companyId: this.loginData.companyId } }
        );
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            let employees = response.data.data;
            employees.forEach(object => {
              this.empMap.set(object.empId, object);
            });
            try {
              response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/project/get_all",
              { params: { companyId: this.loginData.companyId } }
              );
              if(response.data.success == "true") {
                if(response.data.data.length > 0) {
                  let projects = response.data.data;
                  this.projects = projects;
                  projects.forEach(object => {
                    this.proMap.set(object.empId, object);
                  });
                }
              }
            } catch (error) {
              //console.log(error);
            }
            this.getScreenshots();
          }
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getScreenshots() {
      this.loader = true;
      try {
        const response = await axios.get(
          process.env.VUE_APP_SCREENSHOT_URL + "/screenshot/get_dashboard_images",
          { params: { companyId: this.loginData.companyId,timezone: this.loginData.timeZone, limit: 10} }
        );

        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            for(var i = 0;i < response.data.data.length;i++){
              let img = {};
              img.time = response.data.data[i].time;
              let ts = response.data.data[i].time.split(":");
              img.timeMin = (parseInt(ts[0]) * 60) + parseInt(ts[1]);
              
              let emp = {}
              emp.value = response.data.data[i].empId;
              emp.text = this.empMap.get(response.data.data[i].empId).name;
              img.emp = emp;

              let p = {};
              if(response.data.data[i].projectId && this.proMap.get(response.data.data[i].projectId)) {
                p.value = response.data.data[i].projectId;
                p.text = this.proMap.get(response.data.data[i].projectId).projectName;
                img.project = p;
              } else {
                p.value = 0;
                p.text = '';
                img.project = p;
              }

              img.src = response.data.data[i].image;
              img.sensitive = response.data.data[i].isSensitive;

              this.imgs.push(img);
            }
          }
        } else {
          this.loader = false;
        }

      } catch (error) {
        this.loader = false;
      }
      this.loader = false;
    },
    async getCompanyDetails() {
      this.companyDetailsLoader = true;
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/account/get_dashboard_company_details",
          { params: { companyId: this.loginData.companyId} }
        );
        if(response.data.success == "true") {
          this.companyDetails = response.data.data;
        }
      } catch (error) {
        //console.log(error);
      }
      this.companyDetailsLoader = false;
    },
    async getDashboardAttData() {
      this.dashboardAttDataLoader = true;
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/employee/get_dashboard_attendance_data",
          { params: { companyId: this.loginData.companyId } }
        );

        if(response.data.success == "true") {
          this.dashboardAttendanceData = response.data.data;
        }
      } catch (error) {
        //console.log(error);
      }
      this.dashboardAttDataLoader = false;
    },
    async getDashboardActivityData() {
      this.dashboardActivityDataLoader = true;
      try {
        const response = await axios.get(process.env.VUE_APP_ACTIVITY_URL + "/activity_report/dashboard_activity_data",
          { params: { companyId: this.loginData.companyId } }
        );
        
        if(response.data.success == "true") {
          this.dashboardActivityData = response.data.data;
          if(response.data.data.mostAppUsed.length > 0) {
            for(var i = 0;i < response.data.data.mostAppUsed.length;i++){
              this.salesAnalyticsDonutChart.series[i] = response.data.data.mostAppUsed[i].appCount;
              this.salesAnalyticsDonutChart.chartOptions.labels[i] = response.data.data.mostAppUsed[i].appName;
            }
          }
          window.dispatchEvent(new Event("resize"));
        }
      } catch (error) {
        //console.log(error);
      }
      this.dashboardActivityDataLoader = false;
    },
    async getDashboardAppData() {
      this.dashboardAppDataLoader = true;
      try {
        const response = await axios.get(process.env.VUE_APP_APP_URL + "/app_report/get_dashboard_app_data",
          { params: { companyId: this.loginData.companyId } }
        );
        if(response.data.success == "true") {
          this.dashboardAppData = response.data.data;
        }
      } catch (error) {
        //console.log(error);
      }
      this.dashboardAppDataLoader = false;
    },
    async getAllNotices() {
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/account/get_notices",
          { params: { companyId: this.loginData.companyId } }
        );
        if(response.data.success == "true") {
          this.ChatData = response.data.data;
        }
      } catch (error) {
       // console.log(error);
      }
      //this.handleScroll();
    },
    razorpay() {
      const options = {
        key: "rzp_test_9eN5mP6Wzv2Uer", // Enter the Key ID generated from the Dashboard
        amount: "500", // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
        currency: "INR",
        name: "Acme Corp",
        description: "Test Transaction",
        image: "https://example.com/your_logo",
        order_id: "order_JRTWaTOK5HiFJE", //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
        handler: function (response){
            alert(response.razorpay_payment_id);
            alert(response.razorpay_order_id);
            alert(response.razorpay_signature)
        },
        prefill: {
            name: "Gaurav Kumar",
            email: "gaurav.kumar@example.com",
            contact: "9999999999"
        },
        notes: {
            address: "Razorpay Corporate Office"
        },
        theme: {
            color: "#3399cc"
        }
    }; 
    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
    },
    formSubmit() {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      
      if (this.$v.$invalid) {
        return;
      } else {
        this.chat.noticeId = this.ChatData.length;
        this.chat.message = this.chat.message.trim();
        const currentDate = new Date();
        const timestamp = Date.now();

        this.chat.companyId = this.loginData.companyId;
        this.chat.time = currentDate.getHours() + ":" + currentDate.getMinutes();
        this.chat.timestamp = timestamp;
        this.chat.status = 0;

        let dupChatData = JSON.parse(JSON.stringify(this.chat))
        this.ChatData.push(dupChatData);
        let formData = new FormData();
        formData.append("notice", JSON.stringify(dupChatData));

        axios
          .post(process.env.VUE_APP_EMPLOYEE_URL + "/account/send", formData)
          .then((res) => {
            if(res.data.success == "true") {
              dupChatData.noticeId = res.data.noticeId;
              dupChatData.status = 1;
            } else {
              dupChatData.status = 2;
            }
            return res;
        })
        .catch((err) => {
          dupChatData.status = 2;
          return err;
        });
        this.handleScroll();
      }
      this.submitted = false;
      this.chat = {};
    },
    copyUrl() {
        /*const el = document.createElement('textarea');
        el.value = 'https://workrhythm.net/download/WRSetup.exe';
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;                         
        el.select();            
        document.execCommand('copy');          
        document.body.removeChild(el);          
        if (selected) {                  
          document.getSelection().removeAllRanges();
          document.getSelection().addRange(selected);
        }*/
        navigator.clipboard.writeText('https://workrhythm.net/download/WRSetup.exe');
        this.btnText = 'menuitems.dashboards.data.linkCopied';
    },
    handleScroll() {
      if (this.$refs.current.$el) {
        setTimeout(() => {
          this.$refs.current.SimpleBar.getScrollElement().scrollTop =
            this.$refs.current.SimpleBar.getScrollElement().scrollHeight + 1500;
        }, 500);
      }
    },
    showDownloadModels() {
      this.btnText = 'menuitems.dashboards.data.copyLink';
      this.showDownloadsModel = true;
    },
    showStartJourneyModels() {
      this.showStartJourneyModel = true;
    },
    isZohoCallBack(absoluteURL) {
      if(absoluteURL) {
        const myArray = absoluteURL.split("?");
        if(myArray.length < 2) {
          return;
        }

        const queryArray = myArray[1].split("&");
        if(queryArray.length < 2) {
          return;
        }

        let code = '';
        let location = '';
        for(var i = 0;i < queryArray.length;i++) {
          let paramArray = queryArray[i].split("=");
          if(paramArray[0] === 'code') {
            code = paramArray[1];
          }
          if(paramArray[0] === 'location') {
            location = paramArray[1];
          }
        }
        if(code == '') {
          return;
        }
        this.generateZohoToken(code, location);
      }
    },
    async generateZohoToken(code, location) {
        let formData = new FormData();
        formData.append("companyId", this.loginData.companyId);
        formData.append("loginId", this.loginData.loginId);
        formData.append("accessCode", code);
        formData.append("locale", location);

        axios
          .post(process.env.VUE_APP_EMPLOYEE_URL + `/account/integrate_zoho`, formData)
          .then((res) => {
            if(res.data.success == "true") {
              Swal.fire({
                title: "Zoho Integrated!",
                text: "Screenshots will be uploaded to Zoho WorkDrive.",
                icon: 'success',
                onClose: () => {
                  window.location.href = "https://workrhythm.net/account/#/integrations";
                }
              });
            } else {
              Swal.fire({
                title: "Error!",
                text: "Oops! Some error occured in Integration.",
                icon: 'error',
                onClose: () => {
                  window.location.href = "https://workrhythm.net/account/#/integrations";
                }
              });
            }
            return res;
          })
          .catch((err) => {
            Swal.fire({
              title: "Error!",
              text: "Oops! Some error occured in Integration.",
              icon: 'error',
              onClose: () => {
                window.location.href = "https://workrhythm.net/account/#/integrationss";
              }
            });
            return err;
          });
    }
  },

  created() {
    this.loginData = JSON.parse(localStorage.getItem('user'));
    this.isZohoCallBack(window.location.href);
    const d = new Date();
    this.todaysDayOfWeek = d.getDay();
    this.companyDetails.companyId = this.loginData.companyId;
    this.companyDetails.companyName = this.loginData.companyName;
    this.companyDetails.remDays = "N.A";
    this.companyDetails.avail = "N.A";
    this.getCompanyDetails();
    this.getAllEmployees();
    this.getDashboardAttData();
    this.getDashboardActivityData();
    this.getDashboardAppData();
    //this.getAllNotices();
    //this.getScreenshots();
  },
  mounted() {
    window.dispatchEvent(new Event("resize"));
    /*var container2 = document.querySelector(
      "#containerElement .simplebar-content-wrapper"
    );
    container2.scrollTo({ top: 2000, behavior: "smooth" });*/
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('menuitems.dashboards.text')"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-4">
                <div class="d-flex">
                  <div class="row me-3 is-loading">
                      <div class="preloader-component" v-show="false">
                        <div class="status">
                          <div class="spinner-chase">
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                          </div>
                        </div>
                      </div>
                      <div class="avatar-sm col-lg-10 align-self-center" style="height : 3.6em; width : 5.2em;">
                            <span
                              class="
                                avatar-title
                                rounded-circle
                                bg-soft bg-primary
                                text-primary
                                fs-1
                              "
                              v-if="companyDetails.companyName != null"
                              >{{companyDetails.companyName.charAt(0)}}</span
                            >
                      </div>
                      <div class="flex-grow-1  col-lg-2 align-self-center">
                        <div class="text-muted">
                          <p class="mb-2">{{ $t('menuitems.dashboards.data.welcomeTo') }} WorkRhythm</p>
                          <h5 class="mb-1">{{companyDetails.companyName}}</h5>
                          <p class="mb-0">{{companyDetails.tagLine}}</p>
                        </div>
                      </div>
                      <button @click="showStartJourneyModels" class="btn btn-link mb-1"><i class="fas fa-route align-middle me-1 fs-5"></i> {{ $t('menuitems.dashboards.data.learnTo') }}</button>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 align-self-center">
                <div class="text-lg-center mt-4 mt-lg-0">
                  <div class="row">
                    <div class="col-4">
                      <div>
                        <p class="text-dark text-truncate mb-2">
                          {{ $t('menuitems.dashboards.data.presentToday') }}
                        </p>
                        <h5 class="badge bg-primary font-size-20 mb-0"><b-spinner
                        v-if="dashboardAttDataLoader"
                        type="grow"
                        style="width: 0.4rem; height: 0.4rem;"
                        class="m-2"
                        variant="light"
                        role="status"
                      ></b-spinner><span v-else style="cursor: pointer;" @click="presentListModal = true">{{dashboardAttendanceData.presentToday}}</span></h5>
                      </div>
                    </div>
                    <div class="col-4">
                      <div>
                        <p class="text-dark text-truncate mb-2">{{ $t('menuitems.dashboards.data.absentToday') }}</p>
                        <h5 class="badge bg-danger font-size-20 mb-0"><b-spinner
                        v-if="dashboardAttDataLoader"
                        type="grow"
                        style="width: 0.4rem; height: 0.4rem;"
                        class="m-2"
                        variant="light"
                        role="status"
                      ></b-spinner><span v-else style="cursor: pointer;" @click="absentListModal = true">{{dashboardAttendanceData.absentToday}}</span></h5>
                      </div>
                    </div>
                    <div class="col-4">
                      <div>
                        <p class="text-dark text-truncate mb-2">{{ $t('menuitems.dashboards.data.online') }}</p>
                        <h5 class="badge bg-success font-size-20 mb-0"><b-spinner
                        v-if="dashboardAttDataLoader"
                        type="grow"
                        style="width: 0.4rem; height: 0.4rem;"
                        class="m-2"
                        variant="light"
                        role="status"
                      ></b-spinner><span v-else style="cursor: pointer;" @click="onlineListModal = true">{{dashboardAttendanceData.onlineToday}}</span></h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-2 d-none d-lg-block">
                <div class="clearfix mt-4 mt-lg-0">
                  <button @click="showDownloadModels" class="btn btn-primary"><i class="bx bx-download align-middle me-1 fs-5"></i> {{ $t('menuitems.dashboards.data.downloadClient') }}</button>
                  <!--<b-dropdown
                    class="float-end"
                    right
                    variant="primary"
                    menu-class="dropdown-menu-end"
                    @click="showDownloadsModel = true" 
                  >
                    <template v-slot:button-content>
                      <i class="bx bx-download align-middle me-1 fs-5"></i> Download Client
                    </template>
                    <b-dropdown-item @click="$router.push('/settings');">Manage</b-dropdown-item>
                    <b-dropdown-item @click="showDownloadsModel = true">Download Setup</b-dropdown-item>
                  </b-dropdown>-->
                </div>
              </div>
            </div>
            <!-- end row -->
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-4">
        <div class="card bg-soft bg-primary">
          <div>
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-3">
                  <h5 class="text-primary">{{ $t(quotes[todaysDayOfWeek].day) }}</h5>
                  <p>{{ $t(quotes[todaysDayOfWeek].quote) }}</p>

                  <ul class="ps-3 mb-0">
                    <li class="py-1">{{companyDetails.remDays}} {{ $t('menuitems.dashboards.data.daysLeft') }} <span v-if="companyDetails.remDays == 0" style="color: red;">{{ $t('menuitems.dashboards.data.accountExpired') }}.</span></li>
                    <li class="py-1">{{companyDetails.avail}} {{ $t('menuitems.dashboards.data.licenseAvaliable') }}</li>
                  </ul>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-8">
        <div class="row">
          

          <div class="col-sm-4">
              <div class="is-loading">
                <div class="preloader-component" v-show="dashboardActivityDataLoader">
                  <div class="status">
                    <div class="spinner-chase">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex align-items-center mb-3">
                      <div class="avatar-xs me-3">
                        <span
                          class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-18"
                        >
                          <i class="bx bx-time-five"></i>
                        </span>
                      </div>
                      <h5 class="font-size-14 mb-0">{{ $t('menuitems.dashboards.data.avgWorkinhHours') }}</h5>
                    </div>
                    <div class="text-muted mt-4">
                      <h4>
                        {{dashboardActivityData.avgWorkingHrs}}
                        <i v-if="dashboardActivityData.isIncreased == 1" class="mdi mdi-chevron-up ms-1 text-success"></i>
                        <i v-if="dashboardActivityData.isIncreased == 0 && dashboardActivityData.percentageChanged > 0" class="mdi mdi-chevron-down ms-1 text-danger"></i>
                      </h4>
                      <div class="d-flex">
                        <span v-if="dashboardActivityData.isIncreased == 1" class="badge badge-soft-success font-size-12"
                          >+ {{dashboardActivityData.percentageChanged}} %</span
                        >
                        <span v-if="dashboardActivityData.isIncreased == 0 && dashboardActivityData.percentageChanged == 0"  class="badge badge-soft-warning font-size-12"
                          >{{dashboardActivityData.percentageChanged}} %</span
                        >
                        <span v-if="dashboardActivityData.isIncreased == 0 && dashboardActivityData.percentageChanged > 0" class="badge badge-soft-danger font-size-12"
                          >- {{dashboardActivityData.percentageChanged}} %</span
                        >
                        <span class="ms-2 text-truncate">{{ $t('menuitems.dashboards.data.fromPreviousMonth') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>

          <div class="col-sm-4">
            <div class="is-loading">
              <div class="preloader-component" v-show="dashboardAttDataLoader">
                <div class="status">
                  <div class="spinner-chase">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center mb-3">
                    <div class="avatar-xs me-3">
                      <span
                        class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-18"
                      >
                        <i class="bx bx-timer"></i>
                      </span>
                    </div>
                    <h5 class="font-size-14 mb-0">{{ $t('menuitems.dashboards.data.avgAttendance') }}</h5>
                  </div>
                  <div class="text-muted mt-4">
                    <h4>
                      {{dashboardAttendanceData.avgAttendance}} %
                      <i v-if="dashboardAttendanceData.isIncreased == 1" class="mdi mdi-chevron-up ms-1 text-success"></i>
                      <i v-if="dashboardAttendanceData.isIncreased == 0 && dashboardAttendanceData.percentageChanged != 0" class="mdi mdi-chevron-down ms-1 text-danger"></i>
                    </h4>

                    <div class="d-flex">
                      <span v-if="dashboardAttendanceData.isIncreased == 1" class="badge badge-soft-success font-size-12"
                        >+ {{dashboardAttendanceData.percentageChanged}} %</span
                      >
                      <span v-if="dashboardAttendanceData.isIncreased == 0 && dashboardAttendanceData.percentageChanged != 0" class="badge badge-soft-danger font-size-12"
                        >- {{dashboardAttendanceData.percentageChanged}} %</span
                      >
                      <span v-if="dashboardAttendanceData.isIncreased == 0 && dashboardAttendanceData.percentageChanged == 0" class="badge badge-soft-warning font-size-12"
                        >{{dashboardAttendanceData.percentageChanged}} %</span
                      >
                      <span class="ms-2 text-truncate">{{ $t('menuitems.dashboards.data.fromPreviousMonth') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="is-loading">
              <div class="preloader-component" v-show="dashboardAppDataLoader">
                <div class="status">
                  <div class="spinner-chase">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center mb-3">
                    <div class="avatar-xs me-3">
                      <span
                        class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-18"
                      >
                        <i class="bx bx-block"></i>
                      </span>
                    </div>
                    <h5 class="font-size-14 mb-0">{{ $t('menuitems.dashboards.data.appBlocked') }}</h5>
                  </div>
                  <div class="text-muted mt-4">
                    <h4>
                      {{dashboardAppData.appsBlocked}}
                      <i v-if="dashboardAppData.isIncreased == 1" class="mdi mdi-chevron-up ms-1 text-success"></i>
                      <i v-if="dashboardAppData.isIncreased == 0 && dashboardAppData.percentageChanged > 0.0" class="mdi mdi-chevron-down ms-1 text-danger"></i>
                    </h4>
                    <div class="d-flex">
                      <span v-if="dashboardAppData.isIncreased == 1" class="badge badge-soft-success font-size-12"
                        >+ {{dashboardAppData.percentageChanged}} %</span
                      >
                      <span v-if="dashboardAppData.isIncreased == 0 && dashboardAppData.percentageChanged > 0.0" class="badge badge-soft-danger font-size-12"
                        >- {{dashboardAppData.percentageChanged}} %</span
                      >
                      <span v-if="dashboardAppData.isIncreased == 0 && dashboardAppData.percentageChanged == 0" class="badge badge-soft-warning font-size-12"
                        >{{dashboardAppData.percentageChanged}} %</span
                      >
                      <span class="ms-2 text-truncate">{{ $t('menuitems.dashboards.data.fromPreviousMonth') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
    </div>
    <div class="row">
      <div class="col-xl-8">
        <Earning :dataProp="loginData.companyId"/>
      </div>

      <div class="col-xl-4">
        <div class="is-loading">
          <div class="preloader-component" v-show="dashboardActivityDataLoader">
            <div class="status">
              <div class="spinner-chase">
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">{{ $t('menuitems.dashboards.data.mostAppsUsed') }}</h4>

              <div v-if="salesAnalyticsDonutChart.series[0] > 0 && salesAnalyticsDonutChart.series[1] > 0 && salesAnalyticsDonutChart.series[2] > 0">
                <apexchart
                  class="apex-charts"
                  dir="ltr"
                  height="240"
                  :series="salesAnalyticsDonutChart.series"
                  :options="salesAnalyticsDonutChart.chartOptions"
                ></apexchart>
              </div>
              <div v-if="salesAnalyticsDonutChart.series[0] <= 0 && salesAnalyticsDonutChart.series[1] <= 0 && salesAnalyticsDonutChart.series[2] <= 0">
                <img src="@/assets/images/no-data.png" alt="No Data" style="margin-top: 11%;margin-left: 22%;" height="180" width="180"><br />
              </div>

              <div class="text-center text-muted">
                <div class="row">
                  <div class="col-4">
                    <div class="mt-4">
                      <p class="mb-2 text-truncate">
                        <i class="mdi mdi-circle text-primary me-1"></i>
                        {{salesAnalyticsDonutChart.chartOptions.labels[0]}}
                      </p>
                      <h5>{{salesAnalyticsDonutChart.series[0]}}</h5>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="mt-4">
                      <p class="mb-2 text-truncate">
                        <i class="mdi mdi-circle text-success me-1"></i>
                        {{salesAnalyticsDonutChart.chartOptions.labels[1]}}
                      </p>
                      <h5>{{salesAnalyticsDonutChart.series[1]}}</h5>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="mt-4">
                      <p class="mb-2 text-truncate">
                        <i class="mdi mdi-circle text-danger me-1"></i>
                        {{salesAnalyticsDonutChart.chartOptions.labels[2]}}
                      </p>
                      <h5>{{salesAnalyticsDonutChart.series[2]}}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
            <div class="card-body" style="height: 400px;">
              <h4 class="card-title mb-2">{{ $t('menuitems.dashboards.data.screenshots') }}</h4>
              <div class="is-loading">
                <div class="preloader-component" v-show="loader">
                  <div class="status">
                    <div class="spinner-chase">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <simplebar v-if="imgs.length > 0" style="height: 360px">
                  <div class="popup-gallery d-flex flex-wrap" >
                    <div
                          v-for="(img, index) in imgs"
                          :key="index"
                          class="float-left pt-3 pe-3"
                        >
                          <span class="badge bg-secondary font-size-11 bg-gradient mb-1 text-truncate me-2"
                            >{{ img.time }}</span
                          >
                          <span style="max-width: 78px;" class="badge badge-soft-success font-size-11 bg-gradient mb-1 me-2 text-truncate"
                            >{{ img.emp.text }}</span
                          ><br />
                          <span v-if="img.project && img.project.text != ''">
                          <span style="max-width: 195px;" class="badge badge-soft-info font-size-11 bg-gradient mb-1 text-truncate"
                            >{{ img.project.text }}</span
                          ><br /></span>
                          <img  @click="() => showImg(index)" :src="img.src" width="200" height="120"/>
                          
                    </div>
                  </div>
               </simplebar >
               <div v-if="imgs.length <= 0">
                <img src="@/assets/images/no-data.png" alt="No Data" style="margin-top: 5%;margin-left: 42%;" height="180" width="180"><br />
                <span style="margin-left: 43%;" class="mt-2 text-secondary fw-bold fs-3">{{ $t('menuitems.dashboards.data.noDataFound') }}</span>
              </div>
              </div>
              <vue-easy-lightbox
            :visible="visible"
            :imgs="imgs"
            :index="index"
            @hide="handleHide"
          >
          </vue-easy-lightbox>
            </div>
          </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-4">
      <TopSelling />
      </div>

      <div class="col-xl-4">
        <div class="is-loading">
          <div class="preloader-component" v-show="dashboardAppDataLoader">
            <div class="status">
              <div class="spinner-chase">
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body" style="height: 450px;">
              <h4 class="card-title mb-4">{{ $t('menuitems.dashboards.data.projects') }}</h4>
              <b-tabs active pills nav-class="bg-light rounded" content-class="mt-4">
                <b-tab :title="$t('menuitems.dashboards.data.inWorking')" active>
                  <b-card-text>
                    <simplebar v-if="projects.length > 0" style="max-height: 250px">
                      <div class="table-responsive">
                        <table
                          class="table table-nowrap align-mid table-hover mb-0"
                        >
                          <tbody>
                            <tr v-for="project in projects" :key="project.projectId">
                              <td v-if="project.status != 2">
                                <h5 style="max-width: 160px;" class="text-truncate font-size-14 mb-1">
                                    {{project.projectName}}
                                </h5>
                                <p style="max-width: 180px;" class="text-truncate text-muted mb-0">{{project.projectDescription}}</p>
                              </td>
                              <td v-if="project.status != 2">
                                <div>
                                  <span v-if="new Date().getTime() >= project.deadlineTime" class="text-danger">{{project.deadlineDateTime}}</span>
                                  <span v-if="new Date().getTime() < project.deadlineTime" class="text-success">{{project.deadlineDateTime}}</span>
                                </div>
                              </td>
                            </tr>
                            
                          </tbody>
                        </table>
                      </div>
                    </simplebar>
                    <div v-if="projects.length <= 0">
                      <img src="@/assets/images/no-data.png" alt="No Data" style="margin-top: 6%;margin-left: 25%;" height="180" width="180"><br />
                      <span style="margin-left: 26%;" class="mt-2 text-secondary fw-bold fs-3">{{ $t('menuitems.dashboards.data.noDataFound') }}</span>
                  </div>
                  </b-card-text>
                </b-tab>
                <b-tab :title="$t('menuitems.dashboards.data.completed')">
                  <b-card-text>
                    <simplebar v-if="projects.length > 0" style="max-height: 250px">
                      <div class="table-responsive">
                        <table
                          class="table table-nowrap align-mid table-hover mb-0"
                        >
                          <tbody>
                            <tr v-for="project in projects" :key="project.projectId">
                              <td v-if="project.status == 2">
                                <h5 style="max-width: 160px;" class="text-truncate font-size-14 mb-1">
                                    {{project.projectName}}
                                </h5>
                                <p style="max-width: 180px;" class="text-truncate text-muted mb-0">{{project.projectDescription}}</p>
                              </td>
                              <td v-if="project.status == 2">
                                <div>
                                  <span v-if="project.completionTime >= project.deadlineTime" class="text-danger">{{project.completionDateTime}}</span>
                                  <span v-if="project.completionTime < project.deadlineTime" class="text-success">{{project.completionDateTime}}</span>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </simplebar>
                    <div v-if="projects.length <= 0">
                      <img src="@/assets/images/no-data.png" alt="No Data" style="margin-top: 6%;margin-left: 25%;" height="180" width="180"><br />
                      <span style="margin-left: 26%;" class="mt-2 text-secondary fw-bold fs-3">{{ $t('menuitems.dashboards.data.noDataFound') }}</span>
                  </div>
                  </b-card-text>
                </b-tab>
              </b-tabs>
            </div>

            <!--<div class="card-footer bg-transparent border-top">
              <div class="text-center">
                <a href="javascript: void(0);" class="btn btn-primary">
                  Add new Task
                </a>
              </div>
            </div>-->
          </div>
        </div>
      </div>

      <div class="col-xl-4">
        <div class="is-loading">
          <div class="preloader-component" v-show="dashboardAppDataLoader">
            <div class="status">
              <div class="spinner-chase">
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body" style="height: 450px;">
              <h4 class="card-title mb-4">{{ $t('menuitems.dashboards.data.mostAppBlocked') }}</h4>
              <div v-if="dashboardAppData.mostAppBlocked.length > 0">
                <div class="table-responsive mt-6">
                  <table class="table align-middle mb-3">
                    <tbody>
                      <tr v-for="(item, index) of dashboardAppData.mostAppBlocked" :key="index">
                        <td>
                          <h5 class="col-15 font-size-14 text-truncate mb-2">{{ item.appName }}</h5>
                        </td>
                        <td>
                          <p class="text-muted mb-1">{{ $t('menuitems.dashboards.data.frequency') }}</p>
                          <h5 class="mb-0">{{ item.frequency }} %</h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-if="dashboardAppData.mostAppBlocked.length <= 0">
                <img src="@/assets/images/no-data.png" alt="No Data" style="margin-top: 15%;margin-left: 22%;" height="180" width="180"><br />
                <span style="margin-left: 23%;" class="mt-2 text-secondary fw-bold fs-3">{{ $t('menuitems.dashboards.data.noDataFound') }}</span>
              </div>
              <!--<b-tabs pills nav-class="bg-light rounded" content-class="mt-4">
                <b-tab title="In Process" active>
                  <b-card-text>
                    <simplebar style="max-height: 250px">
                      <div class="table-responsive">
                        <table
                          class="table table-nowrap align-mid table-hover mb-0"
                        >
                          <tbody>
                            <tr>
                              <td style="width: 50px">
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck01"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck01"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Saas Dashboard
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">Assigned to Mark</p>
                              </td>
                              <td style="width: 90px">
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck02"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck02"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a href="javascript: void(0);" class="text-dark"
                                    >New Landing UI</a
                                  >
                                </h5>
                                <p class="text-muted mb-0">Assigned to Team A</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck03"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck03"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Brand logo design
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">Assigned to Janis</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck04"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck04"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <label
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Blog Template UI
                                  </label>
                                </h5>
                                <p class="text-muted mb-0">Assigned to Dianna</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck05"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck05"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Multipurpose Landing
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">Assigned to Team B</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck06"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck06"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Redesign - Landing page
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">Assigned to Jerry</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck07"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck07"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Crypto Dashboard
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">Assigned to Eric</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </simplebar>
                  </b-card-text>
                </b-tab>
                <b-tab title="Upcoming">
                  <b-card-text>
                    <simplebar style="max-height: 250px">
                      <div class="table-responsive">
                        <table
                          class="table table-nowrap align-mid table-hover mb-0"
                        >
                          <tbody>
                            <tr>
                              <td style="width: 50px">
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck01"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck01"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Saas Dashboard
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">Assigned to Mark</p>
                              </td>
                              <td style="width: 90px">
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck02"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck02"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a href="javascript: void(0);" class="text-dark"
                                    >New Landing UI</a
                                  >
                                </h5>
                                <p class="text-muted mb-0">Assigned to Team A</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck03"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck03"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Brand logo design
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">Assigned to Janis</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck04"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck04"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Blog Template UI
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">Assigned to Dianna</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck05"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck05"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Multipurpose Landing
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">Assigned to Team B</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck06"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck06"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Redesign - Landing page
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">Assigned to Jerry</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck07"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck07"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Crypto Dashboard
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">Assigned to Eric</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </simplebar>
                  </b-card-text>
                </b-tab>
                <b-tab title="Completed" active>
                  <b-card-text>
                    <simplebar style="max-height: 250px">
                      <div class="table-responsive">
                        <table
                          class="table table-nowrap align-mid table-hover mb-0"
                        >
                          <tbody>
                            <tr>
                              <td style="width: 50px">
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck01"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck01"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Saas Dashboard
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">Assigned to Mark</p>
                              </td>
                              <td style="width: 90px">
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck02"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck02"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a href="javascript: void(0);" class="text-dark"
                                    >New Landing UI</a
                                  >
                                </h5>
                                <p class="text-muted mb-0">Assigned to Team A</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck03"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck03"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Brand logo design
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">Assigned to Janis</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck04"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck04"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <label
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Blog Template UI
                                  </label>
                                </h5>
                                <p class="text-muted mb-0">Assigned to Dianna</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck05"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck05"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Multipurpose Landing
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">Assigned to Team B</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck06"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck06"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Redesign - Landing page
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">Assigned to Jerry</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="tasklistCheck07"
                                  />
                                  <label
                                    class="form-check-label"
                                    for="tasklistCheck07"
                                  ></label>
                                </div>
                              </td>
                              <td>
                                <h5 class="text-truncate font-size-14 mb-1">
                                  <a
                                    href="javascript: void(0);"
                                    class="text-dark"
                                  >
                                    Crypto Dashboard
                                  </a>
                                </h5>
                                <p class="text-muted mb-0">Assigned to Eric</p>
                              </td>
                              <td>
                                <div>
                                  <ul class="list-inline mb-0 font-size-16">
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-success p-1"
                                      >
                                        <i class="bx bxs-edit-alt"></i>
                                      </a>
                                    </li>
                                    <li class="list-inline-item">
                                      <a
                                        href="javascript: void(0);"
                                        class="text-danger p-1"
                                      >
                                        <i class="bx bxs-trash"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </simplebar>
                  </b-card-text>
                </b-tab>
              </b-tabs>-->
            </div>

            <!--<div class="card-footer bg-transparent border-top">
              <div class="text-center">
                <a href="javascript: void(0);" class="btn btn-primary">
                  Add new Task
                </a>
              </div>
            </div>-->
          </div>
        </div>
      </div>


      <!--<div class="col-xl-4">
        <div class="card">
          <div class="card-body border-bottom">
            <div class="row">
              <div class="col-md-4 col-9">
                <h5 class="font-size-15 mb-1">Notice Board</h5>
                <p class="text-muted mb-0">
                  Notify All
                </p>
              </div>-->
              <!-- <div class="col-md-8 col-3">
                <ul class="list-inline user-chat-nav text-end mb-0">
                  <li class="list-inline-item d-none d-sm-inline-block">
                    <b-dropdown
                      toggle-class="nav-btn"
                      menu-class="dropdown-menu-end"
                      right
                      variant="white"
                    >
                      <template v-slot:button-content>
                        <i class="bx bx-cog"></i>
                      </template>
                      <b-dropdown-item>Clear chat</b-dropdown-item>
                      <b-dropdown-item>Muted</b-dropdown-item>
                      <b-dropdown-item>Delete</b-dropdown-item>
                    </b-dropdown>
                  </li>
                </ul>
              </div> -->
            <!--</div>
          </div>
          <div class="card-body pb-0">
            <div>
              <div class="chat-conversation">
                <ul class="list-unstyled">
                  <simplebar
                    style="height: 260px"
                    ref="current"
                    id="containerElement"
                  >
                    <li>
                      <div class="chat-day-title">
                        <span class="title">Today</span>
                      </div>
                    </li>
                    <li
                      v-for="data of ChatData"
                      :key="data.noticeId"
                      class="right"
                    >
                      <div class="conversation-list">
                        <b-dropdown
                          variant="white"
                          menu-class="dropdown-menu-end"
                          dropright
                          style="float : right;"
                        >
                          <template v-slot:button-content>
                            <i class="bx bx-dots-vertical-rounded"></i>
                          </template>
                          <b-dropdown-item>Edit</b-dropdown-item>
                          <b-dropdown-item>Delete</b-dropdown-item>
                        </b-dropdown>
                        <div class="ctext-wrap">
                         
                          <div class="conversation-name">You</div>
                          <p>{{ data.message }} </p>
                          <p class="chat-time mb-0">
                             <b-spinner
                            small
                            variant="primary"
                            role="status"
                            v-show = "data.status == 0"
                          ></b-spinner>
                           <i class="bx bx-error-circle text-danger fs-5" v-if = "data.status == 2"></i>
                            <i class="bx bx-time-five align-middle me-1 ms-2"></i>
                            {{ data.time }}
                            
                          </p>
                          
                        </div>
                      </div>
                    </li>
                  </simplebar>
                </ul>
              </div>
            </div>
          </div>
          <div class="p-3 chat-input-section">
            <form @submit.prevent="formSubmit" class="row">
              <div class="col">
                <div class="position-relative">
                  <input
                    type="text"
                    v-model="chat.message"
                    class="form-control chat-input"
                    placeholder="Enter Message..."
                    style="padding-right: 10px;"
                  />
                  <div
                    v-if="submitted && $v.chat.message.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.chat.message.required"
                      >This value is required.</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-auto">
                <button type="submit" class="btn btn-primary chat-send w-md">
                  <span class="d-none d-sm-inline-block me-2">Send</span>
                  <i class="mdi mdi-send"></i>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>-->
    </div>

    <b-modal v-model="showDownloadsModel" :title="$t('menuitems.dashboards.data.settings.downloadSetup')" centered hide-footer>
      <div class="row">
          <div class="col-12 mb-2">
              <h4 class="mb-4">{{ $t('menuitems.dashboards.data.settings.systemRequirements') }}</h4>
              <p><i class="bx bxl-windows font-size-17 me-2"></i> OS   : <span class="fw-bold">Windows 7, 8, 10, 11</span></p>
              <p><i class="bx bx-chip font-size-17 me-2"></i> RAM  : <span class="fw-bold">{{ $t('menuitems.dashboards.data.settings.mininmum') }} 2GB</span></p>
              <p><i class="bx bxl-edge font-size-17 me-2"></i> .NET : <span class="fw-bold">4.5 {{ $t('menuitems.dashboards.data.settings.andAbove') }}</span></p>
              <a target="_blank" href="https://workrhythm.net/download/WRSetup.exe" class="btn btn-success me-4">{{ $t('menuitems.dashboards.data.settings.downloadFor') }} Windows <i class="bx bxl-windows font-size-18"></i></a><button @click="copyUrl" class="btn btn-secondary me-4">{{ $t(btnText) }} <i class="bx bx-copy-alt font-size-18"></i></button>
          </div>
        </div>
    </b-modal>
    <b-modal v-model="showStartJourneyModel" :title="$t('menuitems.dashboards.data.startYourJourney')" size="lg" hide-footer>
      <form-wizard @on-complete="showStartJourneySubmit"  color="#556ee6" :finish-button-text="$t('menuitems.dashboards.data.start')" :back-button-text="$t('menuitems.dashboards.data.back')" :next-button-text="$t('menuitems.dashboards.data.next')">
        <tab-content icon="bx bx-user-plus"  :title="$t('menuitems.dashboards.data.step1Title')">
        <span class="fs-3 mt-2 fw-bold">{{ $t('menuitems.dashboards.data.step1') }}</span><br />
            <img
              src="@/assets/images/addEmployeeDoc.png"
              alt
              style="border: 1px solid;"
              height="450"
              width="650"
              class="img-fluid"
            />
        </tab-content>
        <tab-content icon="bx bx-shield-quarter" :title="$t('menuitems.dashboards.data.step2Title')">
        <span class="fs-3 mt-2 mb-2 fw-bold">{{ $t('menuitems.dashboards.data.step2') }}</span><br />
           <img
              src="@/assets/images/installDoc.png"
              alt
              style="border: 1px solid;"
              height="300"
              width="550"
              class="img-fluid"
            />
        </tab-content>
        <tab-content icon="bx bx-check-shield"  :title="$t('menuitems.dashboards.data.step3Title')">
        <span class="fs-3 mt-2  mb-2 fw-bold">{{ $t('menuitems.dashboards.data.step3') }}</span><br />
           <img
              src="@/assets/images/activateDoc.png"
              alt
              style="border: 1px solid;"
              height="300"
              width="550"
              class="img-fluid"
            />
        </tab-content>
      </form-wizard>
    </b-modal>

    <b-modal v-model="presentListModal" size="lg" :title="$t('menuitems.dashboards.data.presentToday') " hide-footer>
      <div class="row mb-4">
        <simplebar style="height: calc(100vh - 398px);overflow-x: hidden;" >
          <div class="table-responsive table-hover mb-0">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col">{{ $t('menuitems.attendance.details') }}</th>
                  <th scope="col">{{ $t('menuitems.attendance.clockIn') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in dashboardAttendanceData.presentList" :key="index">
                  <td>
                    {{data.name}}<br/>
                    <span class="text-secondary">{{data.email}}</span><br/>
                    <span class="text-secondary">{{data.designation}}</span>
                  </td>
                  <td>
                    <span class="text-muted mb-0">{{data.clockIn}}</span><br/> 
                    <span :class="`badge font-size-8 bg-${data.clockInColor}`">{{data.clockInRemarks}}</span>
                  </td>
                
                </tr>
              </tbody>
            </table>
          </div>
        </simplebar>
      </div>
    </b-modal>

    <b-modal v-model="absentListModal" size="lg" :title="$t('menuitems.dashboards.data.absentToday') " hide-footer>
      <div class="row mb-4">
        <simplebar style="height: calc(100vh - 398px);overflow-x: hidden;" >
          <div class="table-responsive table-hover mb-0">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col">{{ $t('menuitems.employee.name') }}</th>
                  <th scope="col">{{ $t('menuitems.employee.email') }}</th>
                  <th scope="col">{{ $t('menuitems.employee.designation') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in dashboardAttendanceData.absentList" :key="index">
                  <td>
                    {{data.name}}
                  </td>
                  <td>
                    <span class="text-secondary">{{data.email}}</span>
                  </td>
                  <td>
                    <span class="text-secondary">{{data.designation}}</span>
                  </td>
                
                </tr>
              </tbody>
            </table>
          </div>
        </simplebar>
      </div>
    </b-modal>

    <b-modal v-model="onlineListModal" size="lg" :title="$t('menuitems.dashboards.data.online') " hide-footer>
      <div class="row mb-4">
        <simplebar style="height: calc(100vh - 398px);overflow-x: hidden;" >
          <div class="table-responsive table-hover mb-0">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col">{{ $t('menuitems.employee.name') }}</th>
                  <th scope="col">{{ $t('menuitems.employee.email') }}</th>
                  <th scope="col">{{ $t('menuitems.employee.designation') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in dashboardAttendanceData.onlineList" :key="index">
                  <td>
                    {{data.name}}
                  </td>
                  <td>
                    <span class="text-secondary">{{data.email}}</span>
                  </td>
                  <td>
                    <span class="text-secondary">{{data.designation}}</span>
                  </td>
                
                </tr>
              </tbody>
            </table>
          </div>
        </simplebar>
      </div>
    </b-modal>
  </Layout>
</template>
<style scoped>
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  width: 100%;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
</style>